<mat-toolbar color="primary">
  <span id="avslutt-møte-transkripsjon-dialog-tittel">{{ 'Lydopptaket av møtet er stoppet'|translate }}</span>
  <button mat-icon-button [attr.aria-label]="'Lukk dialog'|translate" (click)="lukk()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>

<mat-dialog-content class="innhold e2e-avsluttmøtetranskripsjondialog">
  @if (transkripsjonsinformasjon(); as informasjon) {
    <inline-melding type="info" voksHorisontalt="true" data-testid="transkripsjonsstatus">
      <span class="melding">
        @if (informasjon.antallOpptak === 0) {
          {{ 'Det ble ikke gjort noen lydopptak av møtet.'|translate }}
        } @else if (!alleOpptakTranskribertEllerFeilet()) {
          <c3-todelt-pai [totalt]="informasjon.antallOpptak"
                         [andel]="informasjon.antallOpptakTranskribert + informasjon.antallOpptakTranskripsjonFeilet"
                         [konfig]="pieKonfig"
                         bredde="20"/>
          <span>{{ '{varighetTranskribert} av lydopptaket har blitt transkribert, vennligst vent mens resten transkriberes' | translate: {varighetTranskribert: informasjon.varighetTranskribert|duration:'timerMinutterSekunderStandard'} }}</span>
          <button mat-icon-button type="button" (click)="oppdaterInformasjon()" [matTooltip]="'Klikk for å hente oppdatert informasjon'|translate"><mat-icon>refresh</mat-icon></button>
        } @else {
          {{ 'Opptaket ({varighet}) har blitt ferdig transkribert' | translate: {varighet: informasjon.totalVarighet|duration:'timerMinutterSekunderStandard'} }}
        }
      </span>
    </inline-melding>

    <!--@if (informasjon.antallOpptakTranskripsjonFeilet > 0) {
      <inline-melding type="feil" data-testid="transkripsjon-feilet">
        {{ 'Transkripsjonen av {varighet} feilet. Disse blir ikke med i forslaget til protokoll.'
          | translate: {varighet: informasjon.varighetTranskripsjonFeilet|duration:'timerMinutterStandard'} }}
      </inline-melding>
    }-->

    @if (informasjon.antallOpptak > 0) {
      <tips data-testid="protokollforslag-informasjon">
        @if (!harTilgangTilProtokollforslag) {
          {{ 'Du er skjermet for en eller flere av sakene i møtet, og kan derfor ikke generere forslag til protokoll.'|translate }}
        } @else if (protokollforslagTilgjengelig()) {
          {{ 'Forslaget til protokoll er generert, og ligger klart på siden for redigering av protokollen.'|translate }}
        } @else if (alleOpptakTranskribertEllerFeilet()) {
          {{ 'Forslaget til protokoll blir tilgjengelig på siden for redigering av protokollen.'|translate }}
        } @else {
          {{ 'Forslaget til protokoll kan genereres når alle lydopptakene er transkribert, og blir da tilgjengelig på siden for redigering av protokollen.'|translate }}
        }
      </tips>
    }

  } @else {
    <p class="laster" data-testid="laster">{{ 'Henter status for transkripsjonen …'|translate }}</p>
  }

  @if (sisteFeil() != null) {
    <p class="feil" data-testid="feil">{{ sisteFeil() }}</p>
  }

</mat-dialog-content>

<mat-dialog-actions align="center">
  <div>
    <button mat-button type="button" data-testid="fortsett-opptak" (click)="fortsettOpptaket()" [disabled]="arbeiderPaagaar()">
      <mat-icon>play_circle</mat-icon>
      {{ 'Fortsett opptaket'|translate }}
    </button>
    @if (kanGenerereProtokollforslag()) {
      <button mat-raised-button color="primary" type="button" cdkFocusInitial data-testid="generer-protokollforslag"
              (click)="genererProtokollforslag()" [disabled]="arbeiderPaagaar()"
              [visSpinner]="genererer()" spinnerTekst=" {{ 'Genererer forslag til protokoll'|translate }}">
        {{ 'Generer forslag til protokoll'|translate }}
      </button>
    } @else if(harTilgangTilProtokollforslag && transkripsjonsinformasjon()!.antallOpptak > 0 && protokollforslagTilgjengelig()){
      <button mat-raised-button color="primary" type="button" cdkFocusInitial data-testid="rediger-protokoll"
              (click)="gaaTilRedigerProtokoll()">
        {{ 'Rediger protokoll'|translate }}
      </button>
    }
    <button mat-button type="button" data-testid="lukk" (click)="lukk()" [disabled]="arbeiderPaagaar()">
      {{ 'Lukk'|translate }}
    </button>
  </div>
</mat-dialog-actions>
